import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useAlert, types } from 'react-alert';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { useAdmin, useMaster, useGoogleMap } from '../../../model/hooks';
import { PaperWithTitle, PagingTable, ConfirmDialog, SelectFacility, SelectPrefecture, PrimaryButton, GoogleMap, } from '../../components';
import * as Constants from '../../common/constants';
import { Job } from '../../../model/firestore_model';
import { useChangeEvent } from '../../../model/hooks/common/ChangeEventHooks';
export const ClinicList = () => {
    var _a, _b, _c, _d;
    const { t } = useTranslation();
    const reactAlert = useAlert();
    const { loadClinicList, loading, columns, updateClinic } = useAdmin();
    const { master } = useMaster();
    const { loadingGeocode, geocoding } = useGoogleMap();
    const { changeText, changeNumSelect } = useChangeEvent();
    const [rows, setRows] = useState([]);
    const [isOpenDialog, setIsOpenDialog] = useState(false);
    const [documentReference, setDocumentReference] = useState(null);
    const [id, setId] = useState('');
    const [corporateName, setCorporateName] = useState('');
    const [facilityName, setFacilityName] = useState('');
    const [facilityDiv, setFacilityDiv] = useState(0);
    const [lastName, setLastName] = useState('');
    const [firstName, setFirstName] = useState('');
    const [tel, setTel] = useState('');
    const [mailaddress, setMailaddress] = useState('');
    const [prefecture, setPrefecture] = useState(0);
    const [prefectureLabel, setPrefectureLabel] = useState('');
    const [address, setAddress] = useState('');
    const [lat, setLat] = useState(0);
    const [lng, setLng] = useState(0);
    const [isLockMap, setIsLockMap] = useState(false);
    const loadData = async (lastDocument) => {
        const result = await loadClinicList(lastDocument);
        return result.data.map((item) => {
            var _a, _b, _c, _d, _e, _f;
            return {
                id: item.id,
                corporateName: item.corporateName,
                facilityName: item.clinicName,
                facilityDiv: (_c = (_b = (_a = master) === null || _a === void 0 ? void 0 : _a.facilityList) === null || _b === void 0 ? void 0 : _b.find((d) => d.id === item.facilityId)) === null || _c === void 0 ? void 0 : _c.text,
                address: `${(_f = (_e = (_d = master) === null || _d === void 0 ? void 0 : _d.prefectureList) === null || _e === void 0 ? void 0 : _e.find((val) => val.id === item.prefectureId)) === null || _f === void 0 ? void 0 : _f.text}${item.locationAddress}`,
                email: item.email,
                tel: item.tel,
                detail: item,
            };
        });
    };
    const onClickExpandMore = async () => {
        if (rows.length > 0) {
            const lastRow = rows.slice(-1)[0];
            const _rows = await loadData(lastRow.detail.snapshot);
            if (_rows.length > 0) {
                setRows(rows.concat(_rows));
            }
        }
    };
    const getInitialData = async () => {
        try {
            const _rows = await loadData();
            setRows(_rows);
        }
        catch (e) {
            if (e instanceof Error) {
                reactAlert.show(e.message, { type: types.ERROR });
            }
        }
    };
    useEffect(() => {
        if (!master)
            return;
        getInitialData();
    }, [master]);
    const onChangePrefecture = (e, child) => {
        setIsLockMap(true);
        setPrefecture(e.target.value);
        setPrefectureLabel(child.props.children);
    };
    const onChangeAddress = (e) => {
        setIsLockMap(true);
        setAddress(e.target.value);
    };
    const onClickDetail = (id) => {
        var _a, _b, _c;
        const row = rows.find((item) => item.id === id);
        setDocumentReference(row.detail.documentReference);
        setId(row.id);
        setCorporateName(row.corporateName);
        setFacilityName(row.facilityName);
        setFacilityDiv(row.detail.facilityId);
        setLastName(row.detail.lastNameOfRecruiter);
        setFirstName(row.detail.firstNameOfRecruiter);
        setTel(row.tel);
        setMailaddress(row.email);
        setPrefecture(row.detail.prefectureId);
        setPrefectureLabel((_c = (_b = (_a = master) === null || _a === void 0 ? void 0 : _a.prefectureList) === null || _b === void 0 ? void 0 : _b.find((val) => val.id === row.detail.prefectureId)) === null || _c === void 0 ? void 0 : _c.text);
        setAddress(row.detail.locationAddress);
        setLat(row.detail.latitude);
        setLng(row.detail.longitude);
        setIsOpenDialog(true);
    };
    const onClickCheckMap = async () => {
        try {
            const result = await geocoding(`${prefectureLabel}${address}`);
            setLat(result.lat);
            setLng(result.lng);
            setIsLockMap(false);
        }
        catch (e) {
            reactAlert.show(t('エラーが発生しました'), { type: types.ERROR });
        }
    };
    const onDragEnd = (lat, lng) => {
        setLat(lat);
        setLng(lng);
        reactAlert.show(t('地図上の位置を更新しました'), { type: types.SUCCESS });
    };
    const onCloseDialog = () => setIsOpenDialog(false);
    const onClickPositive = async () => {
        try {
            const item = Job.Clinic.fromRawValue(documentReference, corporateName, facilityName, facilityDiv, tel, mailaddress, prefecture, address, firstName, lastName, lat, lng);
            await updateClinic(item);
            getInitialData();
            setIsOpenDialog(false);
            reactAlert.show(t('更新しました'), { type: types.SUCCESS });
        }
        catch (e) {
            if (e instanceof Error) {
                reactAlert.show(e.message, { type: types.ERROR });
            }
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(SContainer, null,
            React.createElement(SGrid, { container: true },
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(PaperWithTitle, { title: "\u30AF\u30EA\u30CB\u30C3\u30AF\u4E00\u89A7" },
                        React.createElement(PagingTable, { columns: columns, rows: rows, loading: loading, onClickDetailButton: onClickDetail, onClickExpandMore: onClickExpandMore }))))),
        React.createElement(ConfirmDialog, { isOpen: isOpenDialog, title: t('クリニック情報編集'), negativeLabel: t('キャンセル'), positiveLabel: t('更新'), onClose: onCloseDialog, onClickNegative: onCloseDialog, onClickPositive: onClickPositive, loading: loading },
            React.createElement(SGrid, { container: true, spacing: 3, justify: "center" },
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(TextField, { required: true, label: "ID", value: id, disabled: true, fullWidth: true })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(TextField, { required: true, label: t('契約者名'), value: corporateName, onChange: changeText(setCorporateName), fullWidth: true })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(TextField, { required: true, label: t('施設名'), value: facilityName, onChange: changeText(setFacilityName), fullWidth: true })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(SelectFacility, { value: facilityDiv, menuItems: (_b = (_a = master) === null || _a === void 0 ? void 0 : _a.facilityList) === null || _b === void 0 ? void 0 : _b.map((d) => {
                            return { value: d.id, text: d.text };
                        }), onChange: changeNumSelect(setFacilityDiv) })),
                React.createElement(Grid, { item: true, xs: 6 },
                    React.createElement(TextField, { required: true, label: t('姓'), value: lastName, onChange: changeText(setLastName), fullWidth: true })),
                React.createElement(Grid, { item: true, xs: 6 },
                    React.createElement(TextField, { required: true, label: t('名'), value: firstName, onChange: changeText(setFirstName), fullWidth: true })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(TextField, { required: true, label: t('電話番号(数字のみ)'), value: tel, onChange: changeText(setTel), fullWidth: true })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(TextField, { required: true, label: t('メールアドレス'), value: mailaddress, onChange: changeText(setMailaddress), fullWidth: true })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(SelectPrefecture, { value: prefecture, menuItems: (_d = (_c = master) === null || _c === void 0 ? void 0 : _c.prefectureList) === null || _d === void 0 ? void 0 : _d.map((d) => {
                            return { value: d.id, text: d.text };
                        }), onChange: onChangePrefecture })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(TextField, { required: true, label: t('市区町村番地'), value: address, onChange: onChangeAddress, fullWidth: true })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(PrimaryButton, { inverted: true, size: "small", loading: loadingGeocode, onClick: onClickCheckMap }, "\u4F4F\u6240\u304B\u3089\u5730\u56F3\u3092\u78BA\u8A8D"),
                    React.createElement(SHelperText, null, t('※ピンを移動することで位置を調整できます'))),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(GoogleMap, { lat: lat, lng: lng, disabled: isLockMap, onDragEnd: onDragEnd }))))));
};
const SContainer = styled.div `
  min-height: 92vh;
  padding-left: 48px;
  padding-right: 48px;
  padding-top: 32px;
`;
const SGrid = styled(Grid) `
  padding-top: 32px;
  padding-bottom: 32px;
`;
const SHelperText = styled.p `
  &&& {
    margin-top: 8px;
    margin-bottom: 0;
    color: ${Constants.COLOR.ORANGE700};
    font-size: 14px;
  }
`;
